import { useContent } from "../content/ContentContext";
import { SectionLabel } from "../components/Ui";
import { Reveal } from "../components/Reveal";

export default function ApproachSection() {
  const { content } = useContent();
  const a = content.site.approach;
  return (
    <section id="approach" data-testid="section-approach" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-12 sm:px-6 lg:px-8 lg:py-20">
      <Reveal>
        <SectionLabel>{a.label}</SectionLabel>
        <h2 className="mt-5 max-w-2xl font-serif text-3xl font-semibold tracking-tight text-plum sm:text-4xl lg:text-5xl" data-testid="approach-heading">
          {a.heading}
        </h2>
        <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink">{a.intro}</p>
      </Reveal>

      <ol className="mt-12 grid grid-cols-1 gap-x-14 gap-y-10 md:grid-cols-2" data-testid="approach-stages">
        {a.stages.map((st, i) => (
          <Reveal key={st.title} delay={(i % 2) * 0.08}>
            <li className="border-t-2 border-lavender pt-6">
              <p className="font-serif text-3xl text-accent">0{i + 1}</p>
              <h3 className="mt-3 font-serif text-xl font-medium leading-snug text-plum">{st.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-ink">{st.body}</p>
            </li>
          </Reveal>
        ))}
      </ol>

      <Reveal className="mt-12">
        <SectionLabel>{a.toolsLabel}</SectionLabel>
        <ul className="mt-5 flex flex-wrap gap-2.5" data-testid="approach-tools">
          {a.tools.map((t) => (
            <li
              key={t}
              className="max-w-full rounded-full border border-lavender bg-lavender/50 px-4 py-1.5 text-sm font-medium leading-snug text-plum"
            >
              {t}
            </li>
          ))}
        </ul>
      </Reveal>
    </section>
  );
}
